<template>
  <div class="user-search">
    <v-autocomplete
      v-model="filter.UserId"
      :items="attendends"
      :loading="isLoading"
      :search-input.sync="attendendsSearch"
      chips
      clearable
      hide-details
      hide-selected
      item-text="Name"
      item-value="UserId"
      label="Pretraga polaznika po imenu i/ili prezimenu"
      solo
    >
      <template slot="no-data">
        <v-list-tile>
          <v-list-tile-title>Pretraga korisnika</v-list-tile-title>
        </v-list-tile>
      </template>
      <template slot="selection" slot-scope="{ item, selected }">
        <v-chip
          :selected="selected"
          color="rgb(25, 118, 210)"
          class="white--text"
        >
          <img
            :src="item.ProfileUrl"
            class="exstra-small-profile"
            alt="User profile image"
          />
          <span v-text="item.Name"></span>
        </v-chip>
      </template>
      <template slot="item" slot-scope="{ item }">
        <img
          :src="item.ProfileUrl"
          class="small-profile"
          alt="User profile image"
        />
        <v-list-tile-content>
          <v-list-tile-title v-text="item.Name"></v-list-tile-title>
        </v-list-tile-content>
      </template>
    </v-autocomplete>
    <div class="actions-area">
      <div class="dodajPolaznika-btn" @click="onDodajPolaznikaClicked" :class="{ disabled: addBtnDisabled }">
        Dodaj polaznika/polaznicu
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filter: {},
      attendends: [],
      isLoading: false,
      attendendsSearch: null,
      addBtnDisabled: true,
    };
  },
  methods: {
    getAttendends() {
      this.$store.state.services.userService
        .attendendsList()
        .then((response) => {
          this.attendends = response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onDodajPolaznikaClicked() {
        this.$emit('polaznikAdded', this.attendends.find( x => x.UserId === this.filter.UserId))
    }
  },
  watch: {
    attendendsSearch() {
      //TODO -> optimize with search by name if possible
      if (this.attendends.length > 0) {
        return;
      }
      this.isLoading = true;
      this.getAttendends();
    },
    "filter.UserId"() {
      !this.filter.UserId
        ? (this.addBtnDisabled = true)
        : (this.addBtnDisabled = false);
    },
  },
};
</script>

<style scoped>
.user-search {
  padding: 20px 0;
}
.small-profile {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}
.exstra-small-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;
}
.actions-area {
  padding: 25px 0 0 0;
  display: flex;
  justify-content: flex-end;
}
.dodajPolaznika-btn {
  padding: 15px 20px;
  border-radius: 30px;
  background-color: rgb(25, 118, 210);
  color: white;
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
}
.dodajPolaznika-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed
}
</style>
